import { escapeHtml } from "../router.js";
import { fmtInt } from "../format.js";

/** Result count + "Limpar filtros" link shown under a filter bar. */
export function renderFilterFooter({ total, noun, nounPlural, hasFilters, clearHref, loading = false }) {
  const count =
    total === null || total === undefined
      ? loading
        ? "Carregando…"
        : ""
      : `${fmtInt(total)} ${total === 1 ? noun : nounPlural || noun + "s"}`;
  return `<span class="filters__count">${escapeHtml(count)}</span>${
    hasFilters ? `<a class="inline-link filters__clear" href="${escapeHtml(clearHref)}" data-link>Limpar filtros</a>` : ""
  }`;
}

/** True when any key of `state` differs from `defaults` (keys missing from defaults are ignored). */
export function isDirty(state, defaults) {
  return Object.keys(defaults).some((k) => String(state[k] ?? "") !== String(defaults[k] ?? ""));
}
